export const ShareSource = {
    // 1、个人助力领会员
    //  a.充值页
    //  b.菜单栏“免费领会员”入口
    ASSIST_RECHARGE: 'assist_recharge',
    ASSIST_MENU_FREE: 'assist_menu_free',
    // 2、家长助力领会员
    //  a.亲情账号-为孩子充值页
    ASSIST_PAY_FOR_CHILD: 'assist_pay_for_child',
    // 3、个人分享学习记录
    //  a.菜单栏“分享学习记录”入口
    //  b.答题结果分享
    //  c.往期-学习记录分享
    RECORD_SELF_MENU: 'record_self_menu',
    RECORD_SELF_RESULT: 'record_self_result',
    RECORD_SELF_CALENDAR: 'record_self_calendar',
    // 4、家长分享学习记录
    //  a.亲情账号-分享学习记录
    RECORD_PARENT: 'record_parent',
    // 5、周报学习成果分享（H5）
    WEEKLY_REPORT: 'weekly_report',
    // 6、CEFR测评
    //  a.测评结果页“晒一晒”
    //  b.测评记录页
    //  c.悬浮窗入口
    CEFR_RESULT: 'cefr_result',
    CEFR_RECORD: 'cefr_record',
    CEFR_POPUP: 'cefr_popup',

    WEEKLY_REPORT_SHARE: 'weekly_report_share',
    DAILY_REPORT_SHARE: 'daily_report_share',

    VOTE_SUNMMARY_SHARE: 'vote_summary_share',
}


//////////////////
// WEBPACK FOOTER
// ./app/contants/index.js
// module id = null
// module chunks = 